export default __webpack_public_path__ + "static/media/275.3e45e6db.jpg";